import { EditOutlined } from '@ant-design/icons'
import CheckoutDrawer from 'app/components/Core/Checkout/Drawer'
import { MemberProps } from 'app/components/Core/convention'
import SubItemDetail from 'app/components/Core/SubItem/Detail'
import Button from 'app/components/UI-Elements/General/Button'
import KFooter from 'app/components/UI-Elements/Layout/KFooter'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import SubItemUpdate from 'app/pages/Checkout/Container/SubItem/Update'
import * as React from 'react'
import { useState } from 'react'
import testIds from 'test_ids.json'

interface Props {
  onUpdateSuccess?: () => void
  description?: React.ReactNode
  extra?: React.ReactNode
  showDelete?: boolean
}

const subItemPortalId = 'kfooter-subitem-updata-submit'
const lineItemUpdateDrawerKey = 'line_item_update'

const footer = (
  <KFooter sticky={false}>
    <div id={subItemPortalId} />
  </KFooter>
)

const CheckoutSubItemDetail: React.FC<MemberProps<Partial<ISubItem>, Props>> = ({
  member,
  props = {}
}) => {
  const { tRecordType } = useTranslation({
    recordType: RecordType.subItem
  })
  const [selectedSubItemId, setSelectedSubItemId] = useState<number>(null)

  const onEdit = () => setSelectedSubItemId(member.id)
  const { onUpdateSuccess, showDelete, ...others } = props

  return (
    <>
      <SubItemDetail
        member={member}
        props={{
          extra: (
            <Button
              type="secondary"
              onClick={onEdit}
              icon={<EditOutlined />}
              data-testid={testIds.checkout.machines.sub_item.edit_button}
            />
          ),
          className: 'ant-list-item--unstyled-title',
          ...others
        }}
      />
      <CheckoutDrawer
        title={tRecordType({ id: 'attachment_details' })}
        open={Boolean(selectedSubItemId)}
        onClose={() => setSelectedSubItemId(null)}
        drawerKey={lineItemUpdateDrawerKey}
        footer={footer}>
        <SubItemUpdate
          subItemId={selectedSubItemId}
          onClose={() => setSelectedSubItemId(null)}
          portalId={subItemPortalId}
          showDelete={showDelete}
          onSuccess={onUpdateSuccess}
        />
      </CheckoutDrawer>
    </>
  )
}

export default CheckoutSubItemDetail
